import { Link } from "react-router-dom";

// Official Bridge Partners logo. `light` renders it white for dark backgrounds.
export const Logo = ({ className = "", light = true, size = "h-10" }) => (
  <Link to="/" className={`inline-flex items-center group ${className}`} data-testid="logo-link" aria-label="Bridge Partners — accueil">
    <img
      src="/logo.png"
      alt="Bridge Partners"
      className={`${size} w-auto object-contain transition-transform duration-500 group-hover:-translate-y-0.5 ${light ? "[filter:brightness(0)_invert(1)]" : ""}`}
    />
  </Link>
);
